// extracted by mini-css-extract-plugin
export default {"itemsCard":"CardWorkItems_itemsCard__Wf9dw","overlayContainer":"CardWorkItems_overlayContainer__hza8o","overlay":"CardWorkItems_overlay__26xoW"};